import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import R from 'ramda'
import { withRouter } from 'react-router'
import { Modal } from 'advenio-components'
import { toast } from 'react-toastify'
import ClassRoomList from '../../Components/ClassRoomList'
import ChildrenList from '../../Components/ChildrenList'
import ModalContainer from '../../Components/ModalContainer'
import ModalAssessment from '../../Components/ModalContainer/ModalAssessment'
import ModalHealthTeacher from '../../Components/ModalContainer/ModalHealthTeacher'
import GroupModal from '../../Components/ModalContainer/GroupModal'
import CheckInModal from '../../Components/ModalContainer/CheckInModal'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import ActivityActions from '../../Data/Redux/ActivityRedux'
import HealthCheckActions from '../../Data/Redux/HealthCheckRedux'
import InventoryActions from '../../Data/Redux/InventoryRedux'
import HomeReportActions from '../../Data/Redux/ParentPlatform/HomeReportRedux'
import HealthTeacherActions from '../../Data/Redux/HealthTeacherRedux'
import UsersActions from '../../Data/Redux/UsersRedux'
import { isTeacher, stringContainsAnyOf } from '../../utils/Utils'
import { canUseComingCheckoutSSE, connectComingCheckoutSSE } from '../../services/ComingCheckoutSSE'

const notifyCheckout = (msg, type) => toast(msg, {
  icon: () => <img src="/assets/BabyAvatar.svg" alt="" />,
  type,
})

const Container = styled.div`
  width:100%;
  min-height: 80vh;
  background-color: #F2F2F2;
  display: flex;
  flex-direction: row;
  padding-top: 32px;
  align-items: flex-start;
  justify-content: ${({ teacher }) => teacher ? 'center' : 'flex-start'};
  @media (max-width: 1024px) {
    padding-top: 0;
  }
`

const ChildrenContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  margin-left: ${({ teacher }) => teacher ? '0px' : '80px'};
  align-items: ${({ teacher }) => teacher && 'baseline'};
  @media (max-width: 1024px) {
    width: 65%;
  }
  @media (max-width: 768px) {
    width: 70%;
    margin-left: ${({ teacher }) => teacher ? '0px' : '30px'};
  }
  @media (max-width: 700px) {
    width: 100%;
    margin-left: 0;
  }
`

const ChildrenTitle = styled.div`
  display: flex;
  width: 50%;
  margin-left: ${({ teacher }) => teacher ? '0px' : '50px'};
  align-self: ${({ teacher }) => teacher && 'baseline'};
  @media (max-width: 763px) {
    display: none;
  }
`

class Center extends Component {
  constructor(props) {
    super(props)
    this.state = {
      childrenToRender: [],
      isIndividualActivityModalOpen: false,
      assessment: false,
      checkIn: false,
      checkOut: false,
      child: {},
      activeClassroom: 0,
      activeChild: 0,
      isSickRoom: false,
      tab: '',
      allKids: '',
      modalHealthTeacher:false
    }
    this.onClassroomClick = this.onClassroomClick.bind(this)
    this.setFilter = this.setFilter.bind(this)
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this)
    this.comingCheckoutSSE = null
  }

  componentDidMount() {
    this.startComingCheckoutSSE()
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  }

  componentWillUnmount() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    this.stopComingCheckoutSSE()
  }

  startComingCheckoutSSE() {
    const { user, setCheckout } = this.props

    if (!canUseComingCheckoutSSE(user)) {
      return
    }

    this.stopComingCheckoutSSE()

    this.comingCheckoutSSE = connectComingCheckoutSSE(user.center_id, {
      onCheckout: ({ child_id, classroom_id, action, body }) => {
        if (body) {
          notifyCheckout(body, action === 'save' ? 'info' : 'warning')
        }

        if (child_id && classroom_id && action) {
          setCheckout(child_id, classroom_id, action)
        }
      },
    })
  }

  stopComingCheckoutSSE() {
    if (this.comingCheckoutSSE) {
      this.comingCheckoutSSE.disconnect()
      this.comingCheckoutSSE = null
    }
  }

  handleVisibilityChange() {
    if (document.visibilityState === 'visible') {
      this.startComingCheckoutSSE()
      return
    }

    this.stopComingCheckoutSSE()
  }

  componentWillMount() {
    this.props.getClassrooms({'basic':true,'students':true})
    this.props.getActivityCategories()
    if(isTeacher(this.props.user.role)){
      this.props.getQuestionHelathTeacher()
    }
    if (this.props.activeClassroomId > 0) {
      const [classroom] = this.props.classrooms.filter(room =>
        room.id === this.props.activeClassroomId,
      )
      if (classroom) {
        const childrenToRender = classroom.students
        this.setState({ activeClassroom: this.props.activeClassroomId, childrenToRender })
      }
    }
  }


  componentWillReceiveProps(nextProps) {
    const { healthCheckResponse, studentHomeReport, healthTeacher, loadingHealthTeacher } = nextProps

    if (!nextProps.loading) {
      if (nextProps.classrooms.length > 0) {
        if (nextProps.activeClassroomId === 0) {
          if (this.props.user.role === 'Director') {
            const classroom = nextProps.classrooms[0]
            const childrenToRender = classroom.students
            this.props.setActiveClassroomId(classroom.id)
            if (classroom.type === 'Sick Room') {
              this.setState({ isSickRoom: true })
            } else {
              this.setState({ isSickRoom: false })
            }
            this.setState({ childrenToRender, activeClassroom: nextProps.activeClassroomId })
          } else {
            const classroom = nextProps.classrooms[0] //eslint-disable-line
            const childrenToRender = classroom.students
            this.props.setActiveClassroomId(classroom.id)
            if (classroom.type === 'Sick Room') {
              this.setState({ isSickRoom: true })
            } else {
              this.setState({ isSickRoom: false })
            }
            this.setState({ childrenToRender, activeClassroom: nextProps.activeClassroomId })
          }
        } else {
          const currentClassroom = nextProps.classrooms[0]
          const classroom = nextProps.classrooms.find(room => room.id === nextProps.activeClassroomId)
          if (classroom) {
            const childrenToRender = classroom.students
            this.props.setActiveClassroomId(classroom.id)
            if (classroom.type === 'Sick Room') {
              this.setState({ isSickRoom: true })
            } else {
              this.setState({ isSickRoom: false })
            }
            this.setState({ childrenToRender, activeClassroom: nextProps.activeClassroomId })
          } else {
            this.props.setActiveClassroomId(currentClassroom.id)
          }
        }
      }
      if (healthCheckResponse.status) {
        if (healthCheckResponse !== this.props.healthCheckResponse) {
          if (healthCheckResponse.status !== 'sent home'
            && !healthCheckResponse.new_virtualHealthCheck) {
            const [classroom] = nextProps.classrooms
              .filter(room => room.id === nextProps.activeClassroomId)
            const [newChild] = R.clone(classroom.students
              .filter(student => student.id === this.state.child.id))
            if (newChild) {
              const {
                programLevels,
                sendingHealthcheck,
                study_programs,
              } = nextProps
              newChild.checkin.id = healthCheckResponse.data.latest_health_check.checkin_id
              const studyProgram = study_programs
              .find(program => program.id === newChild.study_program_id)
              const level = programLevels
              .find(levelProgram => levelProgram.id === studyProgram.level_id)
              //FIX: dont show CheckInModal (formato de entrada o salida)
              // if (level && level.name === 'Guardería' && !sendingHealthcheck) {
              //   this.setState({ checkIn: true, child: newChild })
              // }
            }
          } else {
            this.setState({ checkIn: false })
          }
        }
      }
    }
  }

  onClassroomClick(classRoomId) {
    const [classroom] = this.props.classrooms.filter(room => room.id === classRoomId)
    const childrenToRender = classroom.students
    this.props.setActiveClassroomId(Number(classRoomId))
    if (classroom.type === 'Sick Room') {
      this.setState({ childrenToRender, activeClassroom: classRoomId, isSickRoom: true })
    } else {
      this.setState({ childrenToRender, activeClassroom: classRoomId, isSickRoom: false })
    }
  }

  setFilter(filter, inUse) {
    const classroomIndex = R.findIndex(R.propEq('id', this.props.activeClassroomId))(this.props.classrooms)
    if (inUse) {
      this.setState({ tab: '' })
    }
    if (filter === 'all') {
      const classroom = this.props.classrooms[classroomIndex]
      const childrenToRender = classroom.students
      this.setState({ childrenToRender })
    } else if (filter === 'active') {
      const classroom = this.props.classrooms[classroomIndex]
      const childrenToRender = classroom.students.filter(student => (student.checkin.id !== null))
      this.setState({ childrenToRender })
    } else {
      const classroom = this.props.classrooms[classroomIndex]
      const childrenToRender = classroom.students.filter(student => (student.checkin.id === null))
      this.setState({ childrenToRender })
    }
  }



  viewProfile = (profileId) => {
    this.props.setActiveStudentId(Number(profileId))
    this.props.history.push(`/classroom/${this.state.activeClassroom}/student/${profileId}`)
  }

  openIndividualActivityModal = (child) => {
    this.props.getPhotoCatalogue()
    this.setState({ isIndividualActivityModalOpen: true, child })
  }

  checkIn = (child) => {
    this.setState({ checkIn: true, child })
  }

  checkOut = (child) => {
    this.props.setActiveStudentId(child.id)
    this.setState({ checkOut: true, child })
  }

  assessment = (child) => {
    const { healthTeacher, user} = this.props
    let assessment = true
    let modalHealthTeacher= false
    // // TODO : descomentar cuando el rh este liberado
/*    if(isTeacher(user.role) && healthTeacher.length === 0){
      modalHealthTeacher = true

    }else{
      assessment = true
    }*/
    this.setState({ child, assessment, modalHealthTeacher })
  }

  closeModal = () => {
    this.setState({ isIndividualActivityModalOpen: false })
  }

  closeGroupModal = () => {
    this.props.closeActivity()
    this.setState({ tab: 'all' })
  }

  closeAssessment = () => {
    this.setState({ assessment: false })
  }

  closeCheckIn = () => {
    this.setState({ checkIn: false })
  }

  closeCheckOut = () => {
    this.setState({ checkOut: false })
  }
  closeModalTeacher = () => this.setState({ modalHealthTeacher: false })


  render() {
    const {
      sendingCheckin,
      sendingActivity,
      sendingHealthcheck,
      user,
      classrooms,
      healthCheck,
      loading,
      loadingHomeReport,
      studentHomeReport,
      loadingHealthTeacher,
      healthTeacher,
      postHelathTeacher,
      questionsTeacher,
    } = this.props

    const {
      modalHealthTeacher
    } = this.state

    // if ( classrooms.length < 1 || loading) {

    // }
    const [activeClassroom] = classrooms ?
      classrooms.filter(room => room.id === this.state.activeClassroom) : [0]

    return (loading ?
      <Modal isOpened={loading} loading={loading} />
      :
      <Container teacher={user.role === 'Teacher'}>
        <ModalAssessment
          open={this.state.assessment && !loadingHomeReport}
          child={this.state.child}
          children={this.state.childrenToRender}
          closeAssessment={this.closeAssessment}
          extra={this.props.healthCheck.Extra}
          revise={this.props.healthCheck.Revise}
          askParent={this.props.healthCheck["Ask Parent"]}
          postChildHealthCheck={this.props.postChildHealthCheck}
          isTeacher={user.role === 'Teacher'}
          healthCheckResponse={this.props.healthCheckResponse}
          loading={sendingHealthcheck}
          studentHomeReport={studentHomeReport}
        />
        <CheckInModal
          open={this.state.checkIn || this.state.checkOut}
          child={this.state.child}
          closeCheckIn={this.closeCheckIn}
          closeCheckOut={this.closeCheckOut}
          consumables={this.props.inventory.Consumables}
          accessories={this.props.inventory.Accessories}
          postStudentCheckIn={this.props.postStudentCheckIn}
          updateCheckinInventory={this.props.updateCheckinInventory}
          postStudentCheckOut={this.props.postStudentCheckOut}
          isTeacher={user.role === 'Teacher'}
          type={this.state.checkIn ? 'checkin' : 'checkout'}
          studyPrograms={this.props.study_programs}
          loading={sendingCheckin}
        />
        <ModalContainer
          isOpen={this.state.isIndividualActivityModalOpen}
          child={this.state.child}
          children={this.state.childrenToRender}
          closeModal={this.closeModal}
          categories={this.props.activityCategories}
          postActivity={this.props.postActivity}
          postFinishActivity={this.props.postFinishActivity}
          loading={sendingActivity}
          activeClassroom={activeClassroom}
        />
        <ModalHealthTeacher
          open={modalHealthTeacher}
          teacher={user.id}
          closeAssessment={this.closeModalTeacher}
          questions={questionsTeacher}
          postHelathTeacher={postHelathTeacher}
          loading={loadingHealthTeacher}
        />
        <GroupModal
          open={this.props.activityResponse.openActivity}
          children={this.state.childrenToRender}
          closeModal={this.closeGroupModal}
          classrooms={this.props.classrooms}
          categories={this.props.activityCategories}
          postGroupActivity={this.props.postGroupActivity}
          loading={this.props.loadingGroupActivity}
          user={this.props.user}
        />
        {user.role !== 'Teacher' && <ClassRoomList
          classrooms={this.props.classrooms}
          onClassroomClick={this.onClassroomClick}
          activeClassroomId={this.state.activeClassroom}
          userType={this.props.user.role}
        />}
        <ChildrenContainer teacher={user.role === 'Teacher'}>
          <ChildrenTitle teacher={user.role === 'Teacher'}>
            <h4>{activeClassroom ? activeClassroom.name : ''}</h4>
          </ChildrenTitle>
          {this.props.loading ? <div>3</div>: (
            <ChildrenList
              teacher={user.role === 'Teacher'}
              nurse={user.role === 'Nurse'}
              children={this.state.childrenToRender}
              filter={this.setFilter}
              viewProfile={this.viewProfile}
              openModal={this.openIndividualActivityModal}
              openAssessment={this.assessment}
              openCheckIn={this.checkIn}
              openCheckOut={this.checkOut}
              isSickRoom={this.state.isSickRoom}
              categories={this.props.activityCategories}
              director={this.props.user.user_type === 'Center Operation'}
              tab={this.state.tab}
              studyPrograms={this.props.study_programs}
              levels={this.props.programLevels}
              getHomeReport={this.props.getHomeReportStudent}
              getHelathTeacher={this.props.getHelathTeacher}
              healthTeacher={healthTeacher}
              user={this.props.user}
              setCheckout={this.props.setCheckout}
              postUserTokenFCM= {this.props.postUserTokenFCM}
            />)
          }
        </ChildrenContainer>
      </Container>
      )
  }
}

Center.propTypes = {
  getClassrooms: PropTypes.func.isRequired,
  classrooms: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  activeClassroomId: PropTypes.number.isRequired,
  setActiveStudentId: PropTypes.func.isRequired,
  setActiveClassroomId: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
}
Center.defaultProps = {
  healthTeacher:[],
  classrooms:[]
}

const mapStateToProps = ({ activity, classrooms, healthCheck, inventory, ...state }) => ({
  user: state.auth.user,
  loading: classrooms.get.fetching,
  classrooms: classrooms.get.results,
  activeClassroomId: classrooms.activeClassroomId,
  healthCheck: healthCheck.get.results,
  healthCheckResponse: healthCheck,
  healthTeacher: state.healthTeacher.get.results,
  questionsTeacher: state.healthTeacher.questions.results,
  inventory: inventory.get.results,
  activityCategories: activity.get.results,
  activityResponse: activity,
  inventorFull: inventory,
  study_programs: state.study_programs.get.results,
  sendingHealthcheck: healthCheck.sending.fetching,
  sendingActivity: activity.sending.fetching,
  sendingCheckin: inventory.sending.fetching,
  programLevels: state.programLevels.get.results,
  studentHomeReport: state.home_report.student_home_report.result,
  loadingHomeReport: state.home_report.student_home_report.fetching,
  loadingHealthTeacher: state.healthTeacher.get.fetching,
  loadingGroupActivity: activity.new_group_activity ? activity.new_group_activity.fetching : false,
})

const mapDispatchToProps = dispatch => ({
  getClassrooms: (query) => dispatch(ClassroomActions.getRequest(query, true)),
  setActiveClassroomId: id => dispatch(ClassroomActions.setActiveClassroomId(id)),
  setActiveStudentId: id => dispatch(ClassroomActions.setActiveStudentId(id)),
  postChildHealthCheck: (id, info, isTeacher) => dispatch(HealthCheckActions.postHealthCheckRequest(id, info, isTeacher)),
  postStudentCheckIn: (checkin_id, info) => dispatch(InventoryActions.postCheckInRequest(checkin_id, info)),
  postStudentCheckOut: (checkin_id, info, isTeacher) => dispatch(InventoryActions.postCheckOutRequest(checkin_id, info, isTeacher)),
  getActivityCategories: () => dispatch(ActivityActions.getRequest()),
  getPhotoCatalogue: () => dispatch(ActivityActions.getPhotoCatalogueRequest()),
  postActivity: (id, info) => dispatch(ActivityActions.postActivityRequest(id, info)),
  postGroupActivity: info => dispatch(ActivityActions.postGroupActivityRequest(info)),
  postFinishActivity: (id, info) => dispatch(ActivityActions.postFinishActivityRequest(id, info)),
  closeActivity: () => dispatch(ActivityActions.closeActivity()),
  getHealthCheckQuestions: () => dispatch(HealthCheckActions.getRequest()),
  updateCheckinInventory: (checkinId, payload) =>
    dispatch(InventoryActions.updateInventoryRequest(checkinId, payload)),
  getHomeReportStudent: studentId => dispatch(HomeReportActions.getHomeReportStudentRequest(studentId,true)),
  getHelathTeacher: userId => dispatch(HealthTeacherActions.getRequest(userId,true)),
  getQuestionHelathTeacher: () => dispatch(HealthTeacherActions.getQuestionHealthTeacherRequest()),
  postHelathTeacher: (userId ,data)=> dispatch(HealthTeacherActions.postHealthTeacherRequest(userId,data)),
  setCheckout: (student_id, classroom_id, action) => dispatch(ClassroomActions.setCheckout(student_id, classroom_id, action)),
  postUserTokenFCM: (id, data) => dispatch(UsersActions.postUserTokenFCMRequest(id, data)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Center))



// WEBPACK FOOTER //
// ./src/Containers/Center/Center.jsx